import * as requestFromServer from "./PublicNoticesCrud";
import { callTypes, publicNoticeSlice } from "./PublicNoticesSlice";

const {actions} = publicNoticeSlice;

export const getPublicNotices = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getPublicNotices(queryParams)
    .then(response => {
      dispatch(actions.publicNoticesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllPublicNotices = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllPublicNotices(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getNewPublicNotice = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
  .getNewPublicNotice()
  .then(response => {
    dispatch(actions.publicNoticeFetched(response.data));
  })
  .catch(error => {
      
  });
};

export const getPublicNotice = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
  .getPublicNotice(id)
  .then(response => {
    dispatch(actions.publicNoticeFetched(response.data));
  })
  .catch(error => {
      
  });
};

export const downloadAttachment = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
  .downloadAttachment(id)
  .then(response => {
    dispatch(actions.actionCompleted());
    return response.data;
  })
  .catch(error => {
    dispatch(actions.actionCompleted());
  });
};

export const savePublicNotice = publicNotice => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .savePublicNotice(publicNotice)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });    
};

export const deletePublicNotices = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deletePublicNotices(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanPublicNoticesState = () => dispatch => {
  dispatch(actions.publicNoticesStateCleaned());
}